import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getOrders} from "../store/actions/ordersActions";
import {setPriceFromInit, setPriceToInit} from "../store/actions/settingsActions";
import Settings from "./orders/settings.jsx";
import {nest} from "d3-collection";
import {
    defaultDateFormat,
    formatDate,
    formatDateWithTime,
    formatDbDate,
    moment,
    ordersStructure,
    translateOptions
} from "../config";
import {timeFrom, timeTo} from "../utils/timeInterval";
import {SET_PRICE_FROM_INIT} from "../store/types";

function Orders() {

    // Импорт диспатчера
    const dispatch = useDispatch();

    // Подписка на изменение стейта ордеров и настроек
    const isLoad = useSelector(state => state.orders.isLoad);
    const ordersFull = useSelector(state => state.orders.items);
    const settings = useSelector(state => state.settings);

    // Получение списка ордеров
    useEffect(() => {
        dispatch(getOrders());
    }, []);

    let demoOrdersWrapperClass = '';

    if (window.demoChartPage) {
        demoOrdersWrapperClass = 'orders-list--hide';
    }

    // Обработка класса, который ожидает загрузку
    let ordersWrapperClass = 'orders-list orders-list--loading';

    if (isLoad) {
        ordersWrapperClass = 'orders-list';
    }

    // Проверяем и обрабатываем фильтрацию
    let orders = ordersFull.filter(item => {
        let inResult = true;

        function checkFromTo(keyFrom, keyTo, keyValue) {
            if (settings[keyFrom] !== '') {
                if (parseFloat(item[keyValue]) < parseFloat(settings[keyFrom]) || !item[keyValue]) {
                    inResult = false;
                }
            }

            if (settings[keyTo] !== '') {
                if (parseFloat(item[keyValue]) > parseFloat(settings[keyTo]) || !item[keyValue]) {
                    inResult = false;
                }
            }
        }

        function checkDate(keyFrom, keyTo, keyValue) {
            let date = new Date(formatDbDate(new Date(+item[keyValue])));

            // if (item.status !== 'PARTIALLY_FILLED' && item.status !== 'NEW') {
            if (settings[keyFrom] !== '') {
                let from = new Date(formatDbDate(new Date(+settings[keyFrom])));

                if (date < from || !date) {
                    inResult = false;
                }
            }
            // }

            if (settings[keyTo] !== '') {
                let to = new Date(formatDbDate(new Date(+settings[keyTo])));


                if (date > to || !date) {
                    inResult = false;
                }

            }


        }

        checkFromTo('priceFrom', 'priceTo', 'orderPrice');
        checkDate('timeFrom', 'timeTo', 'date_number');

        return inResult;
    });

    // Проверяем и обрабатываем фильтрацию
    orders = orders.filter(item => {
        let inResult = true;

        function checkFromTo(keyFrom, keyTo, keyValue) {
            if (settings[keyFrom] !== '') {
                if (parseFloat(item[keyValue]) < parseFloat(settings[keyFrom]) || !item[keyValue]) {
                    inResult = false;
                }
            }

            if (settings[keyTo] !== '') {
                if (parseFloat(item[keyValue]) > parseFloat(settings[keyTo]) || !item[keyValue]) {
                    inResult = false;
                }
            }
        }

        function checkSelect(keySelect, keyValue) {
            if (settings[keySelect] !== '') {
                if (item[keyValue] !== settings[keySelect] || !item[keyValue]) {
                    inResult = false;
                }
            }
        }

        function checkDate(keyFrom, keyTo, keyValue) {

            let date = new Date(formatDbDate(new Date(+item[keyValue])));

            // if (item.status !== 'PARTIALLY_FILLED' && item.status !== 'NEW') {
            if (settings[keyFrom] !== '') {
                let from = new Date(formatDbDate(new Date(+settings[keyFrom])));

                if (date < from || !date) {
                    inResult = false;
                }
            }


            // }

            // if (item.status !== 'PARTIALLY_FILLED' && item.status !== 'NEW') {
            if (settings[keyTo] !== '') {
                let to = new Date(formatDbDate(new Date(+settings[keyTo])));

                if (date > to || !date) {
                    inResult = false;
                }
            }
            // }
        }

        checkFromTo('filtertxCNTFrom', 'filtertxCNTTo', 'txCNT');
        checkFromTo('filterIterBuyFrom', 'filterIterBuyTo', 'IterBuy');
        checkFromTo('filterIterSellFrom', 'filterIterSellTo', 'IterSell');
        checkFromTo('filterTargIdxFrom', 'filterTargIdxTo', 'TargIdx');
        checkFromTo('filterorderIdFrom', 'filterorderIdTo', 'orderId');
        checkFromTo('filteramountForOperFrom', 'filteramountForOperTo', 'amountForOper');
        checkFromTo('filterorderAmountForOperExecFrom', 'filterorderAmountForOperExecTo', 'orderAmountForOperExec');
        checkFromTo('filterorderPriceFrom', 'filterorderPriceTo', 'orderPrice');
        checkFromTo('filterorderOrigAmountFrom', 'filterorderOrigAmountTo', 'orderOrigAmount');
        checkFromTo('filterorderAmountFrom', 'filterorderAmountTo', 'orderAmount');
        checkFromTo('filterorderExecFrom', 'filterorderExecTo', 'orderExec');
        checkFromTo('filterfeeResultFrom', 'filterfeeResultTo', 'feeResult');
        checkFromTo('filterorderRemainsFrom', 'filterorderRemainsTo', 'orderRemains');
        checkFromTo('filterOrderIdPairedFrom', 'filterOrderIdPairedTo', 'orderIdPaired');

        checkSelect('filterSide', 'side');
        checkSelect('filterStatus', 'status');
        checkSelect('filterType', 'type');
        checkSelect('filterOrderAlg', 'OrderAlg');
        checkSelect('filterIsRobotOrder', 'isRobotOrder');
        checkSelect('filterCycleEnd', 'cycleEnd');
        checkSelect('filterCycleStage', 'cycleStage');
        checkSelect('filterBaseCurr', 'baseCurr');


        checkDate('filterSdTimeFrom', 'filterSdTimeTo', 'sdTime');
        checkDate('filterFdTimeFrom', 'filterFdTimeTo', 'fdTime');

        return inResult;
    });

    // Проверяем и обрабатываем сортировку по первому ключу
    if (settings.sort.key) {

        if (settings.sort.direction === 'asc') {
            orders = orders.sort((a, b) => {
                if (a[settings.sort.key] < b[settings.sort.key]) {
                    return -1;
                }
                if (a[settings.sort.key] > b[settings.sort.key]) {
                    return 1;
                }

                return 0;
            });
        } else {
            orders = orders.sort((a, b) => {
                if (a[settings.sort.key] > b[settings.sort.key]) {
                    return -1;
                }
                if (a[settings.sort.key] < b[settings.sort.key]) {
                    return 1;
                }

                return 0;
            });
        }
    }

    // Проверяем и обрабатываем сортировку по второму ключу
    if (settings.sort2.key) {
        if (settings.sort2.direction === 'asc') {
            orders = orders.sort((a, b) => {
                if (a[settings.sort.key] === b[settings.sort.key]) {
                    if (a[settings.sort2.key] < b[settings.sort2.key]) {
                        return -1;
                    }
                    if (a[settings.sort2.key] > b[settings.sort2.key]) {
                        return 1;
                    }

                    return 0;
                }
            });
        } else {
            orders = orders.sort((a, b) => {
                if (a[settings.sort.key] === b[settings.sort.key]) {
                    if (a[settings.sort2.key] > b[settings.sort2.key]) {
                        return -1;
                    }
                    if (a[settings.sort2.key] < b[settings.sort2.key]) {
                        return 1;
                    }

                    return 0;
                }
            });
        }
    }

    // Проверяем и обрабатываем сортировку по третьему ключу
    if (settings.sort3.key) {
        if (settings.sort3.direction === 'asc') {
            orders = orders.sort((a, b) => {
                if (a[settings.sort.key] === b[settings.sort.key]) {
                    if (a[settings.sort2.key] === b[settings.sort2.key]) {
                        if (a[settings.sort3.key] < b[settings.sort3.key]) {
                            return -1;
                        }
                        if (a[settings.sort3.key] > b[settings.sort3.key]) {
                            return 1;
                        }

                        return 0;
                    }
                }
            });
        } else {
            orders = orders.sort((a, b) => {
                if (a[settings.sort.key] === b[settings.sort.key]) {
                    if (a[settings.sort2.key] === b[settings.sort2.key]) {
                        if (a[settings.sort3.key] > b[settings.sort3.key]) {
                            return -1;
                        }
                        if (a[settings.sort3.key] < b[settings.sort3.key]) {
                            return 1;
                        }

                        return 0;
                    }
                }
            });
        }
    }


    // Проверяем и обрабатываем группировку
    if (settings.group.key) {
        orders = nest().key(item => {
            return item[settings.group.key];
        }).entries(orders);
    }


    // Проверяем и обрабатываем настройку полей, выводим финальный список
    function createOrdersItems() {
        let key = 0;

        if (isLoad && orders.length === 0) {
            ordersWrapperClass = 'orders-list orders-list--empty';
            return <div className="orders-list__empty">Ордеры не найдены</div>;
        }

        if (settings.group.key) {
            let subKey = 0;

            return orders.map(item => {
                key++;

                let SubGroups = item.values.map(subItem => {
                    subKey++;
                    return createOrderItem(subItem, `order-item-subgroup-${key}-${subKey}`);
                });

                return <div key={`order-item-group-${key}`} className={'orders-list__group'}>
                    <div className={'orders-list__group-header'}>
                        {`${ordersStructure[settings.group.key].name} (${ordersStructure[settings.group.key].desc}): ${item.key !== 'null' ? item.key : translateOptions.notValue}`}
                    </div>

                    {SubGroups}
                </div>;
            });


        } else {
            return orders.map(item => {
                key++;
                return createOrderItem(item, `order-item-${key}`);
            });
        }

    }

    function createOrderItem(order, key) {
        let pair = order.pair = 'BTCUSDT' ? 'BTC/USDT' : order.pair;
        let side;
        let sideClass;
        let priceVolumeClass;
        let priceVolumePrefix;
        let time = order.fdTime == null ? order.sdTime : order.fdTime;
        let toFixed = [];
        let multiply = '';

        // Отметка продажи или покупки
        if (order.side === 'BUY') {
            side = jsTranslations.buy;
            sideClass = 'orders-list__item-type orders-list__item-type--green';
            priceVolumeClass = 'orders-list__item-desc-price-volume orders-list__item-desc-price-volume--green';
            priceVolumePrefix = '';
            multiply = '÷';
        } else {
            side = jsTranslations.sell;
            sideClass = 'orders-list__item-type orders-list__item-type--red';
            priceVolumeClass = 'orders-list__item-desc-price-volume orders-list__item-desc-price-volume--red';
            priceVolumePrefix = '';
            multiply = 'x';
        }

        // Проверка валюты ордера для округления
        if (order.amountForOperCurr === 'BTC') {
            toFixed = [6, 2];
        } else {
            toFixed = [2, 6];
        }

        // Получение значений для кастомных полей
        let customFields = createOrderItemCustomFields(order);

        return <div key={key} className="orders-list__item">
            <div className="orders-list__item-main">
                <div className="orders-list__item-logo exchange-logo exchange-logo--binance"/>
                <div className="orders-list__item-pair">{pair}</div>
                <div className={sideClass}>{side}</div>
            </div>
            <div className="orders-list__item-natural">
                {customFields}
            </div>
            <div className="orders-list__item-desc">
                <div className="orders-list__item-desc-time">{formatDateWithTime(+order.date_number)}</div>
                <div className="orders-list__item-desc-price">
                    <div className={priceVolumeClass}>
                        <div
                            className="orders-list__item-desc-price-volume-number">{priceVolumePrefix}{order.amountForOper.toFixed(toFixed[0])}</div>
                        <div className="orders-list__item-desc-price-volume-currency">{order.amountForOperCurr}</div>
                    </div>
                    <div className="orders-list__item-desc-price-separator">{multiply}</div>
                    <div className="orders-list__item-desc-price-course">{order.orderPrice.toFixed(2)}</div>
                </div>
                <div className="orders-list__item-desc-volume">
                    <div
                        className="orders-list__item-desc-volume-number">{order.orderAmount ? order.orderAmount.toFixed(toFixed[1]) : 0}</div>
                    <div className="orders-list__item-desc-volume-currency">{order.orderAmountCurr}</div>
                </div>
            </div>
        </div>;
    }

    function createOrderItemCustomFields(order, key) {
        let activeCustomFields = [];

        for (let key in settings.customFields) {
            if (settings.customFields[key]) {
                activeCustomFields.push(key);
            }
        }

        let innerKey = 0;

        function createCustomField(field, key) {
            let fieldName = ordersStructure[field].name;
            let fieldValue = order[field];

            function checkNull(val) {
                if (val === null) {
                    return 0.000000000;
                } else {
                    return val;
                }
            }

            if (ordersStructure[field].isNeedCurrency) {

                let keyCurr = field + 'Curr';

                if (field === 'feeResult') {
                    keyCurr = 'feeCurr';
                }

                if (order[keyCurr] === 'BTC') {
                    fieldValue = checkNull(order[field]).toFixed(6) + ' BTC';
                } else {
                    fieldValue = checkNull(order[field]).toFixed(2) + ' USDT';
                }
            }

            if (ordersStructure[field].isDate) {
                if (order[field] === null || order[field] === 0) {
                    fieldValue = '-';
                } else {
                    fieldValue = formatDateWithTime(new Date(+order[field]));
                }
            }

            if (field === 'isRobotOrder') {
                fieldValue = order[field];
            }

            if (field === 'orderIdPaired') {
                if (order[field] === 0 || !order[field]) {
                    fieldValue = '-';
                }
            }


            return <div key={key} className="orders-list__item-natural-field">
                <div className="orders-list__item-natural-field-name">{fieldName}</div>
                <div className="orders-list__item-natural-field-value">{fieldValue}</div>
            </div>;
        }

        return activeCustomFields.map(field => {
            innerKey++;
            return createCustomField(field, `order-item-custom-${key}-${innerKey}`);

        });
    }


    let ordersItems = createOrdersItems(orders);

    return (
        <div>
            <Settings isLoad={isLoad}/>
            <div className={`${ordersWrapperClass} ${demoOrdersWrapperClass}`}>
                {ordersItems}
            </div>
        </div>
    );
}

export default Orders;
